import { render, staticRenderFns } from "./accountElement.vue?vue&type=template&id=66128902&scoped=true"
import script from "./accountElement.vue?vue&type=script&lang=js"
export * from "./accountElement.vue?vue&type=script&lang=js"
import style0 from "./accountElement.vue?vue&type=style&index=0&id=66128902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66128902",
  null
  
)

export default component.exports